import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@postdaily/ui/components/card";
import { Skeleton } from "@postdaily/ui/components/skeleton";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { ConnectGuidesCard } from "@/components/agents/connect-guides-card";
import { ConnectionsCard } from "@/components/agents/connections-card";
import { PageHeader } from "@/components/page-header";
import { useTRPC } from "@/utils/trpc";

export const Route = createFileRoute("/(app)/settings/agents")({
  component: RouteComponent,
});

function RouteComponent() {
  const trpc = useTRPC();
  const server = useQuery(trpc.agents.server.queryOptions());

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        size="lg"
        title="AI agents"
        description="Let AI apps like Claude, ChatGPT and Cursor work with your posts."
      />
      {server.isPending ? (
        <Skeleton className="h-72 w-full" />
      ) : server.data ? (
        <ConnectGuidesCard urls={server.data} />
      ) : (
        <Card>
          <CardHeader>
            <CardTitle>Not available here</CardTitle>
            <CardDescription>
              The MCP server is not configured for this PostDaily environment.
            </CardDescription>
          </CardHeader>
        </Card>
      )}
      <ConnectionsCard />
    </div>
  );
}
